import React, { useState } from 'react';
import s from './collection-description.scss';
import { Box, Text, TextButton } from '@wix/design-system';
import { composer } from '../../../component-decorators/composer';
import type { TFunction } from 'i18next';
import type { InjectedExperimentsProps } from '@wix/wix-experiments-react';

export interface ICollectionDescriptionProps
  extends Partial<InjectedExperimentsProps> {
  description: string;
  wordsLimit: number;
}

export const CollectionDescription = composer()
  .withExperiments()
  .compose(({ description, wordsLimit }: ICollectionDescriptionProps) => {
    const wordsCount = description?.split(' ').length;
    const descriptionExceedsLimit = wordsCount > wordsLimit;
    const [showingAllText, setShowingAllText] = useState(
      !descriptionExceedsLimit,
    );
    const getDescription = () => {
      return showingAllText
        ? description
        : description?.split(' ').slice(0, wordsLimit).join(' ');
    };
    return (
      <Box direction="vertical" dataHook="collection-description">
        <Text
          weight="thin"
          dataHook="collection-description-content"
          className={s.collectionDescription}
        >
          {getDescription()}
        </Text>
        {description?.split(' ').length > wordsLimit && (
          <ExpansionToggle
            showingAllText={showingAllText}
            expansionToggle={() => setShowingAllText(!showingAllText)}
          />
        )}
      </Box>
    );
  });

const ExpansionToggle = composer()
  .withTranslation()
  .compose(
    ({
      t,
      showingAllText,
      expansionToggle,
    }: {
      t?: TFunction;
      showingAllText: boolean;
      expansionToggle(): void;
    }) => (
      <TextButton size="medium" onClick={expansionToggle} className={s.sizeFix}>
        {showingAllText ? t('collection.readLess') : t('collection.readMore')}
      </TextButton>
    ),
  );
